import InfoIcon from '@mui/icons-material/Info';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { colors, fonts } from '../../utils';

const { red, colorLightBlack, colorInput } = colors;

const { primaryFont } = fonts;

const errorText = {
	color: red,
	fontSize: '1.4rem',
	fontFamily: primaryFont,
	fontWeight: '600',
};

const helperTextStyle = {
	color: colorLightBlack,
	fontSize: '1.4rem',
	fontFamily: primaryFont,
	fontWeight: '600',
	display: 'flex',
	alignItems: 'center',
};

const infoIconStyle = {
	fontSize: '1.6rem',
	marginRight: '0.3rem',
	marginTop: '0.2rem',
	color: 'orange',
};

const InputControl = ({
	state,
	id,
	label,
	variant,
	type,
	value,
	onChange,
	errorMsg,
	name,
	inputRef,
	helperText,
	error,
	onBlur,
	onFocus,
	required,
	disabled,
	defaultState,
	isError,
	isErrorMsg,
	multiline,
	inputProps,
	rows
}) => {
	const [inputValue, setInputValue] = useState('');

	const handleInputChange = (e) => {
		const { value } = e.target;
		if (!inputProps?.maxLength || value.length <= inputProps.maxLength) {
			setInputValue(value);
			if (onChange) {
				onChange(e);
			}
		}
	};

	useEffect(() => {
		if (state) {
			setInputValue(state)
		}
	}, [])


	return (
		<FormControl fullWidth>
			<TextField
				id={id || state}
				variant={variant || 'filled'}
				label={label}
				type={type || 'text'}
				value={state}
				error={error}
				isError={isError}
				name={name}
				defaultValue={defaultState}
				// onChange={(e) => (onChange ? onChange(e) : '')}
				onChange={handleInputChange}
				sx={{
					'& .MuiInputBase-input': {
						fontSize: '1.3rem !important',
						fontWeight: '600 !important',
						fontFamily: primaryFont,
						padding: multiline ? "3rem 1.3rem 0.5rem" : '2.5rem 1.3rem 0.5rem',
						backgroundColor: colorInput,
					},
					'& .css-phksla-MuiInputBase-root-MuiFilledInput-root': {
						padding: multiline && "0px"
					}
				}}
				inputRef={inputRef}
				onBlur={onBlur}
				onFocus={onFocus}
				required={required}
				disabled={disabled}
				multiline={multiline}
				rows={rows}
				inputProps={inputProps}
				helperText={
					inputProps?.maxLength
						? `${inputValue.length}/${inputProps.maxLength} characters`
						: helperText
				}
			/>
			{isErrorMsg && <FormHelperText style={errorText}>{isErrorMsg}</FormHelperText>}
			{errorMsg && <FormHelperText style={errorText}>{errorMsg}</FormHelperText>}
			{helperText && (
				<FormHelperText style={helperTextStyle}>
					<InfoIcon style={infoIconStyle} /> {helperText}
				</FormHelperText>
			)}
		</FormControl>
	);
};

export default InputControl;
